<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <legend>Печать доставки заказов</legend>
        </div>
        <div class="col">
          <div class="text-right pb-3">
            <button :class="withoutNS ? 'btn-success' : 'btn-outline-success'"
                    @click="withoutNS = !withoutNS"
                    class="btn ml-2" type="button">
              Без НС
            </button>
          </div>
        </div>
      </div>
      <list-by-time-and-courier-id
        :withoutNS="withoutNS"
        v-if="$route.query.time && $route.query.panelUserId"
        :allow-printing="true"
        :time="$route.query.time" :panel-user-id="$route.query.panelUserId"
      ></list-by-time-and-courier-id>
      <div v-else>
        <div v-if="!this.$route.query.isArchive">
          <h5>Открытые доставки</h5>
          <div v-for="ptName in customPT" v-show="groupedLists.delivered[ptName]">
            <legend class="text-black-50" style="font-size: 18px;">{{ ptName }}</legend>
            <table class="table table-bordered table-hover table-sm">
              <tbody>
                <tr v-for="(item, index) in groupedLists.delivered[ptName]"
                    :class="{'bg-all-is-passed': item.allIsPassed }">
                  <td width="50">
                    {{ index + 1 }}
                  </td>
                  <td width="120">
                    <router-link
                      :to="{ name: 'print-delivery', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId }}">
                      {{ item.DeliveryDateFormatted }}
                    </router-link>
                  </td>
                  <td class="text-nowrap overflow-hidden"
                      style="text-overflow: ellipsis; overflow: hidden; min-width: 200px">
                    <router-link
                      :to="{ name: 'print-delivery', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId }}">
                      {{ item.PanelUser.Login }}
                    </router-link>
                  </td>
                  <td width="200">
                <span
                  :class="{'text-danger': !item.closedBill, 'text-success': item.closedBill}"
                >{{ item.closedBill ? 'Счет выставлен' : 'Счет не выставлен' }} {{
                    item.isBilledCount
                  }} / {{ item.OrderCount }}</span>
                  </td>
                  <td>
                    {{ item.PanelUser.Lname }} {{ item.PanelUser.Fname }} {{ item.PanelUser.Mname }}
                  </td>
                  <td width="100">{{ item.orderItemSummary }}</td>
                  <td width="100">
                    {{ item.OrderCount }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="this.$route.query.isArchive">
          <h5>Закрытые доставки</h5>
          <div v-for="ptName in customPT" v-show="groupedLists.nonDelivered[ptName]">
            <legend class="text-black-50" style="font-size: 18px;">{{ ptName }}</legend>
            <table class="table table-bordered table-hover table-sm">
              <tbody>
                <tr v-for="(item, index) in groupedLists.nonDelivered[ptName]"
                    :class="{'bg-all-is-passed': item.allIsPassed }">
                  <td width="50">
                    {{ index + 1 }}
                  </td>
                  <td width="120">
                    <router-link
                      :to="{ name: 'print-delivery', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId }}">
                      {{ item.DeliveryDateFormatted }}
                    </router-link>
                  </td>
                  <td class="text-nowrap overflow-hidden"
                      style="text-overflow: ellipsis; overflow: hidden; min-width: 200px">
                    <router-link
                      :to="{ name: 'print-delivery', query: { time: item.DeliveryDate, panelUserId: item.PanelUserId }}">
                      {{ item.PanelUser.Login }}
                    </router-link>
                  </td>
                  <td width="200">
                <span
                  :class="{'text-danger': !item.closedBill, 'text-success': item.closedBill}"
                >{{ item.closedBill ? 'Счет выставлен' : 'Счет не выставлен' }} {{
                    item.isBilledCount
                  }} / {{ item.OrderCount }}</span>
                  </td>
                  <td>
                    {{ item.PanelUser.Lname }} {{ item.PanelUser.Fname }} {{ item.PanelUser.Mname }}
                  </td>
                  <td width="100">
                    {{ item.OrderCount }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ListByTimeAndCourierId
  from '@/admin/modules/Delivery/_components/ListByTimeAndCourierId.vue';
import api from '@/admin/modules/Delivery/api';


export default {
  components: {
    ListByTimeAndCourierId,
  },
  data() {
    return {
      list: [],
      withoutNS: false,
    };
  },
  async created() {
    // await this.fetchList();
    if (this.$route.name === 'print-delivery' && (!Object.values(this.$route.query).length || this.$route.query.isArchive)) {
      await this.fetchList();
    }
  },
  watch: {
    async withoutNS() {
      await this.fetchList();
    },
    async $route(newVal) {
      if (newVal.name === 'print-delivery' && !Object.values(newVal.query).length) {
        await this.fetchList();
      }
    },
  },
  computed: {
    customPT() {
      if (this.list.length) {
        let pts = _.map(this.list, l => l.pts);
        pts = _.uniq(pts);
        return _.reverse(pts);
      }
      return [];
    },
    groupedLists() {
      const data = {
        delivered: [],
        nonDelivered: [],
      };
      if (this.list.length) {
        _.each(this.list, (l) => {
          if (l.nonDeliveryOrdersCount > 0) {
            data.delivered.push(l);
          } else {
            data.nonDelivered.push(l);
          }
        });

        // data.delivered = _.sortBy(data.delivered, col => col.DeliveryDate);
        // data.delivered = _.sortBy(data.delivered, col => col.PanelUser.Login);
        // data.delivered = _.sortBy(data.delivered, col => !col.closedBill);
        // data.delivered = _.sortBy(data.delivered, col => !col.allIsPassed);
        data.delivered = _.orderBy(data.delivered, ['allIsPassed', 'DeliveryDate', 'closedBill', 'PanelUser.Login'],
          ['desc', 'desc', 'asc', 'asc']);
        data.delivered = _.groupBy(data.delivered, 'pts');
        // const bnpo = data.delivered['БН предоплата'];
        // delete data.delivered['БН предоплата'];
        // data.delivered = {
        //   'БН предоплата': bnpo,
        //   ...data.delivered,
        // };
        // console.log(data.delivered)

        // data.nonDelivered = _.sortBy(data.nonDelivered, col => col.DeliveryDate);
        // data.nonDelivered = _.sortBy(data.nonDelivered, col => col.PanelUser.Login);
        // data.nonDelivered = _.sortBy(data.nonDelivered, col => !col.closedBill);

        data.nonDelivered = _.orderBy(data.nonDelivered, ['allIsPassed', 'DeliveryDate', 'closedBill', 'PanelUser.Login'],
          ['desc', 'asc', 'asc', 'asc']);
        data.nonDelivered = _.groupBy(data.nonDelivered, 'pts');
      }
      // console.log('datadata', data);
      return data;
    },
  },
  methods: {
    async fetchList() {
      this.list = [];
      let query = {};
      if (this.withoutNS) {
        query = {withoutPaymentTypes: ['НС']};
      }

      if (this.$route.query.isArchive) {
        query.isArchive = true;
        const {data} = await api.fetchDebtByTourId(query);
        this.list = data;
      } else {
        const {data} = await api.fetchDebtByTourId(query);
        this.list = data;
      }
    },
  },
};
</script>
<style lang="scss">
.bg-all-is-passed {
  background-color: #a6e3a6;

  & * {
    border-width: 2px !important;
    border-color: #439a43 !important;
  }
}
</style>
